//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientBillListApi, clientBillPutApi } from '@/api/enterprise';
export default {
  name: 'ContractRecord',
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    contractDialog: function contractDialog() {
      return import('@/views/customer/contract/components/contractDialog');
    },
    markDialog: function markDialog() {
      return import('@/views/customer/contract/components/markDialog');
    },
    renewCensus: function renewCensus() {
      return import('@/views/customer/contract/components/renewCensus');
    }
  },
  data: function data() {
    return {
      handleData: {},
      renewData: [],
      renewCensusData: [],
      renewTotal: 0,
      configContract: {},
      configRenewCensus: {},
      renewPage: 1,
      where: {
        page: 1,
        limit: 15,
        types: 1
      },
      mark: '',
      configMark: {},
      renewMaxDate: 30
    };
  },
  watch: {
    formInfo: {
      handler: function handler(nVal) {
        nVal.isClient === false ? this.where.cid = nVal.data.id : this.where.eid = nVal.data.id;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getTableData: function getTableData() {
      var _this = this;
      clientBillListApi(this.where).then(function (res) {
        _this.renewData = res.data.list;
        _this.renewCensusData = res.data.renew_census;
        _this.renewTotal = res.data.count;
      });
    },
    renewChange: function renewChange(val) {
      this.where.page = val;
      this.where.types = 1;
      this.getTableData();
    },
    handleContract: function handleContract(type, edit) {
      var row = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var str = '';
      if (type === 1 && edit === 1) {
        str = this.$t('customer.addcollection');
      } else if (type === 1 && edit === 2) {
        str = this.$t('customer.editcollection');
      } else if (type === 2 && edit === 1) {
        str = this.$t('customer.addrenewal');
      } else if (type === 2 && edit === 2) {
        str = this.$t('customer.editrenewal');
      }
      this.configContract = {
        title: str,
        width: '480px',
        edit: edit,
        data: row,
        cid: this.formInfo.data.id,
        eid: this.formInfo.data.eid,
        type: type
      };
      this.$refs.contractDialog.handleOpen();
    },
    isOk: function isOk() {
      this.where.types = 1;
      this.getTableData();
    },
    setRemarks: function setRemarks(row) {
      this.configMark = {
        title: this.$t('customer.remarkinformation'),
        width: '480px',
        id: row.id,
        type: 1,
        mark: row.mark
      };
      this.$refs.markDialog.handleOpen();
    },
    handleRenewCensus: function handleRenewCensus() {
      this.configRenewCensus = {
        title: '合同续费',
        width: '480px',
        data: this.renewCensusData
      };
      this.$refs.renewCensus.handleOpen();
    },
    getRenewDate: function getRenewDate(data) {
      var str = '';
      var days = this.$moment(data).diff(this.$moment(new Date()), 'days');
      if (days > this.renewMaxDate) {
        str = 'color-success';
      } else if (days >= 0 && days <= this.renewMaxDate) {
        str = 'color-warning';
      } else {
        str = 'color-danger';
      }
      return str;
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this2 = this;
      this.$modalSure(this.$t('customer.placeholder23')).then(function () {
        clientBillPutApi(item.id).then(function (res) {
          if (_this2.where.page > 1 && _this2.renewData.length <= 1) {
            _this2.where.page--;
            _this2.where.types = 1;
          }
          _this2.getTableData();
        });
      });
    }
  }
};